<script lang="ts" setup>
import {menuMainItems} from "~~/route/route.config";

const {pageUri} = useI18nCollection();
const {cta} = defineProps<{
    cta: {
        pageRef?: string,
        url?: string,
        label: string,
        external?: boolean
    }
}>();
const {locale} = useI18n();
const ctaUri = computed(() => {
    const menuItem = menuMainItems.find(item => item.identifier === cta.pageRef);
    return menuItem?.path?.[locale.value] || '/';
});

function getUrl() {
    if (cta?.pageRef) {
        return pageUri(ctaUri.value)
    } else if (cta?.url) {
        return cta.url;
    } else {
        return '#';
    }
}
</script>

<template>
  <SiteHydrationSafeLink :external="cta?.external" :to="getUrl()">
    {{ cta.label }}
    <slot name="icon-end"/>
    <IconExternal v-if="cta?.external" class="size-3 ms-2 align-super"/>
  </SiteHydrationSafeLink>
</template>

<style scoped>

</style>
